import { ensureProductAnalyticsAuthBridge } from '@/telemetry/product-analytics-auth-bridge';

export function ProductAnalyticsAuthBridge() {
  ensureProductAnalyticsAuthBridge();

  return null;
}
